export const SIDEBAR_WIDTH = 270;
export const MAX_NAV_COUNTER = 99;
export const SIDEBAR_OPEN_STORAGE_KEY = 'isSidebarOpen';
